import Composite from "./composite/";
import * as types from "./mutationTypes";

export default {
  async redoSurveyItemCompositeMetrics({ state, commit, dispatch }, clickedCategory) {
    if (!state.survey.items) {
      return;
    }
    let cat;
    for (let i = 0; i < state.survey.items.length; i++) {
      const surveyItem = state.survey.items[i];
      if (surveyItem.items && surveyItem.items.length > 0) {
        if(clickedCategory === undefined) {
          surveyItem.items = [];
          commit(types.CLEAR_SURVEY_ITEM_CHILDREN, { surveyItemIndex: i }); //remove composite metrics
          cat = state.categories;
        } else {
           cat = state.categories.filter(el => el == clickedCategory.uuid);
        }
        await dispatch("rebuildCompositeMetrics", {index: i, categories: cat });
      }
    }
  },
  /**
   * Create composite survey items to parent item
   * @param {surveyItem parent} sureyItemParent
   */
  rebuildCompositeMetrics({ state, rootState, commit }, {index, categories}) {
    const categoryTree = rootState.category.categoriesTree;
    
    const surveyItemParent = { ...state.survey.items[index] };
    const newSurveyItemParentWithComposite = Composite.createCompositeMetrics(
      categoryTree,
      surveyItemParent,
      state.survey.default_lang,
      categories ?? state.categories
    );
    commit(types.UPDATE_SURVEY_ITEM, {
      surveyItemIndex: index,
      surveyItem: newSurveyItemParentWithComposite
    });
  },
  removeCompositeMetrics({ commit }, surveyItemParentIndex) {
    commit(types.CLEAR_SURVEY_ITEM_CHILDREN, { surveyItemIndex: surveyItemParentIndex });
  }
};
